import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { signin } from 'src/redux/actions/auth.action';
import { logoutSuccess } from 'src/redux/reducers/auth.slice';
import { IconArrowRight, IconLock, IconMail } from '../components/AuthIcons';
import PasswordInput from '../components/PasswordInput';

const schema = yup.object().shape({
  email: yup.string().email('Enter a valid email').required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(4, 'Password must be at least 4 characters'),
});

function LoginForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const inviteToken = params.get('invite');
  const companyID = params.get('companyID');
  const { isLoading, error } = useSelector((state) => state.login);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: { email: '', password: '' },
  });

  const onSubmit = (model) => {
    dispatch(
      signin(
        { email: model.email, password: model.password },
        history,
        inviteToken && companyID
          ? { inviteToken, companyID }
          : undefined
      )
    );
  };

  return (
    <>
      {inviteToken && companyID && (
        <div className="auth-alert" role="status" style={{ marginBottom: 12 }}>
          Log in with the invited email to join the team.
        </div>
      )}

      {error && (
        <div className="auth-alert auth-alert-error" role="alert">
          {error}
          <button
            type="button"
            onClick={() => dispatch(logoutSuccess())}
            style={{ float: 'right', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 700 }}
            aria-label="Dismiss error"
          >
            ×
          </button>
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="field">
          <label htmlFor="email">Email</label>
          <div className="ctrl">
            <span className="lead">
              <IconMail />
            </span>
            <input
              id="email"
              type="email"
              placeholder="you@company.com"
              className={`inp has-lead ${errors.email ? 'inp-error' : ''}`}
              {...register('email')}
            />
          </div>
          {errors.email && <span className="field-error">{errors.email.message}</span>}
        </div>

        <PasswordInput
          id="password"
          label="Password"
          placeholder="••••••••"
          leadIcon={<IconLock />}
          error={errors.password?.message}
          {...register('password')}
        />

        <div className="row-between">
          <label className="remember">
            <input type="checkbox" />
            Remember me
          </label>
          <Link className="link" to="/forgot-password">
            Forgot password?
          </Link>
        </div>

        <button className="btn-primary" type="submit" disabled={isLoading}>
          {isLoading ? 'Logging in…' : inviteToken ? 'Log in & join team' : 'Log in'}
          <IconArrowRight />
        </button>
      </form>
    </>
  );
}

export default LoginForm;
